export const paths = {
  index: "/",
  checkout: "/checkout",
  contact: "/contact",
  pricing: "/pricing",
  auth: {
    auth0: {
      callback: "/auth/auth0/callback",
      login: "/auth/auth0/login",
    },
    jwt: {
      // login: '/auth/login',
      // register: '/auth/register'
      entry: "/auth/entry",
      entryStart: "/auth/entry/start",
    },
    firebase: {
      login: "/auth/firebase/login",
      register: "/auth/firebase/register",
    },
    amplify: {
      confirmRegister: "/auth/amplify/confirm-register",
      forgotPassword: "/auth/amplify/forgot-password",
      login: "/auth/amplify/login",
      register: "/auth/amplify/register",
      resetPassword: "/auth/amplify/reset-password",
    },
  },
  dashboard: {
    index: "/",
    personal: (ud_id: string) => `/${ud_id}/personal`,
    medical: (ud_id: string) => `/${ud_id}/medical`,
    legacy: (ud_id: string) => `/${ud_id}/legacy`,
    legal: (ud_id: string) => `/${ud_id}/legal`,
    financial: (ud_id: string) => `/${ud_id}/financial`,
    digital: (ud_id: string) => `/${ud_id}/digital`,
    property: (ud_id: string) => `/${ud_id}/property`,
    lwt: (ud_id: string) => `/${ud_id}/wills-and-trusts`,
    fpoa: (ud_id: string) => `/${ud_id}/financial-power-of-attorney`,
    hcd: (ud_id: string) => `/${ud_id}/health-care-directive`,
    account: "/account",
    mybenefits: "/benefits",
    accountSharing: (tab: string) => `/account/${tab}`,
    createWillOrTrust: (estateDocId: string, ud_id: string) =>
      `/${ud_id}/wills-and-trusts/create/${estateDocId}`,
    createHealthCareDirective: (estateDocId: string, ud_id: string) =>
      `/${ud_id}/health-care-directive/create/${estateDocId}`,
    createFinancialPowerOfAttorney: (estateDocId: string, ud_id: string) =>
      `/${ud_id}/financial-power-of-attorney/create/${estateDocId}`,
    customers: {
      index: "/dashboard/customers",
      details: "/dashboard/customers/:customerId",
      edit: "/dashboard/customers/:customerId/edit",
    },
    onboarding: "/onboarding"
  },
  resetPassword: "/reset-password/:token",
  forgotPassword: "/forgot-password?email=:email",
  notAuthorized: "/401",
  notFound: "/404",
  serverError: "/500",
};
